import { RecommendationsBasedOnInterest, usePrioritizeInterestRecommendations } from '../features/recommendations/index.migrated';
import HomePageSection from '../components/Layouts/HomePageSection';
import { RankedRecommendations } from '../features/recommendations/components/RankedRecommendations';
import { useIsVariation } from '../features/experiments/experimentsQueries';
import { jsx as _jsx } from "react/jsx-runtime";
const RecommendationsContainer = ({
  cardSize,
  onRenderEmpty
}) => {
  const {
    prioritizeInterestRecommendations,
    isLoading: prioritizeInterestRecommendationsLoading,
    hasError: prioritizeInterestRecommendationsError
  } = usePrioritizeInterestRecommendations();

  // acad-0011: remove learning-interest recommendations. In the variation we
  // always render ranked recommendations and hide the wizard "update
  // recommendations" link.
  const removeLearningInterestRecommendations = useIsVariation('acad-0011') === true;
  const isLoading = !removeLearningInterestRecommendations && prioritizeInterestRecommendationsLoading;
  const containerError = removeLearningInterestRecommendations ? undefined : prioritizeInterestRecommendationsError;
  const showRankedRecommendations = removeLearningInterestRecommendations || !prioritizeInterestRecommendations;
  return /*#__PURE__*/_jsx(HomePageSection, {
    paddingBlock: "0",
    children: /*#__PURE__*/_jsx("div", {
      "data-loading": isLoading,
      "data-test-id": "recommendation-cards-container",
      children: showRankedRecommendations ? /*#__PURE__*/_jsx(RankedRecommendations, {
        cardSize: cardSize,
        containerError: containerError,
        containerLoading: isLoading,
        hideUpdateRecommendationsLink: removeLearningInterestRecommendations,
        onRenderEmpty: onRenderEmpty
      }) : /*#__PURE__*/_jsx(RecommendationsBasedOnInterest, {
        containerError: containerError,
        containerLoading: isLoading,
        onRenderEmpty: onRenderEmpty
      })
    })
  });
};
export default RecommendationsContainer;